<div class="customer-info-page">
  <h1>{{ 'TO.Order_CustomerInfo_Title' | translate : 'Customer info'}}</h1>

  <div class="customer-info-top">
    <section class="info-card info-card-map">
      <div class="map-frame">
        <img #gmap class="map-frame-image">
      </div>
    </section>

    <div class="customer-info-top-stack">
      <section class="info-card">
        <h2>{{ 'TO.Order_DeliveryAddress_Title' | translate : 'Delivery address'}}</h2>
        <div class="address-block">
          <p class="address-block-name" *ngIf="customerLocationInfo?.DeliveryAddressCustomerName">{{ customerLocationInfo?.DeliveryAddressCustomerName }}</p>
          <p *ngIf="customerLocationInfo?.DeliveryAddress">{{ customerLocationInfo?.DeliveryAddress }}</p>
          <p *ngIf="customerLocationInfo?.DeliveryZipCode || customerLocationInfo?.DeliveryCity">{{ customerLocationInfo?.DeliveryZipCode }} {{ customerLocationInfo?.DeliveryCity }}</p>
          <p *ngIf="customerLocationInfo?.Email"><a class="address-block-link" href="mailto:{{ customerLocationInfo?.Email }}">{{ customerLocationInfo?.Email }}</a></p>
        </div>
      </section>

      <section class="info-card">
        <h2>{{ 'TO.Order_InvoiceAddress_Title' | translate : 'Invoice address'}}</h2>
        <div class="address-block">
          <p class="address-block-name" *ngIf="customerLocationInfo?.InvoiceName">{{ customerLocationInfo?.InvoiceName }}</p>
          <p *ngIf="customerLocationInfo?.InvoiceAddress">{{ customerLocationInfo?.InvoiceAddress }}</p>
          <p *ngIf="customerLocationInfo?.InvoiceZipCode || customerLocationInfo?.InvoiceCity">{{ customerLocationInfo?.InvoiceZipCode }} {{ customerLocationInfo?.InvoiceCity }}</p>
          <p *ngIf="customerLocationInfo?.LegalOrgNo" class="address-block-meta">{{ 'TO.Order_LegalOrgNoLbl' | translate : 'Organisation number'}}: {{ customerLocationInfo?.LegalOrgNo }}</p>
        </div>
      </section>
    </div>

    <section class="info-card info-card-details customer-info-top-details">
      <h2>{{ 'TO.Order_CustomerDetails_Titles' | translate : 'Customer details'}}</h2>
      <div class="details-grid">
        <div class="detail-item" *ngIf="customerLocationInfo?.AxCustomerNo">
          <h5>{{ 'TO.Order_DeliveryAddress_CustomerNo' | translate : 'Customer No'}}</h5>
          <p>{{ customerLocationInfo?.AxCustomerNo }}</p>
        </div>
        <div class="detail-item" *ngIf="customerLocationInfo?.PricelistTitle">
          <h5>{{ 'TO.Order_Pricelist_Title' | translate : 'Price list'}}</h5>
          <p>{{ customerLocationInfo?.PricelistTitle }}</p>
        </div>
        <div class="detail-item" *ngIf="customerLocationInfo?.SalesRepId">
          <h5>{{ 'TO.Order.Customer.txtSalesRep' | translate : 'Sales rep'}}</h5>
          <p>{{ customerLocationInfo?.SalesRepId }}</p>
        </div>
        <div class="detail-item" *ngIf="customerLocationInfo?.Phone">
          <h5>{{ 'TO.Order_DeliveryAddress_StorePhone' | translate : 'Store phone'}}</h5>
          <p>{{ customerLocationInfo?.Phone }}</p>
        </div>
        <div class="detail-item" *ngIf="customerLocationInfo?.LegalOrgNo">
          <h5>{{ 'TO.Order_LegalOrgNoLbl' | translate : 'Organisation number'}}</h5>
          <p>{{ customerLocationInfo?.LegalOrgNo }}</p>
        </div>
        <div class="detail-item" *ngIf="customerLocationInfo?.MobilePhone">
          <h5>{{ 'TO.Order_DeliveryAddress_MobilePhone' | translate : 'Mobile phone'}}</h5>
          <p>{{ customerLocationInfo?.MobilePhone }}</p>
        </div>
      </div>
    </section>
  </div>

  <div class="customer-info-secondary">
    <div class="partner-grid">
      <section class="info-card">
        <h2>{{ 'TO.Order_Contact_ServiceAgent' | translate : 'Service agent'}}</h2>
        <div class="partner-details">
          <div class="partner-details-row" *ngIf="servicePartner?.DeliveryAddressCustomerName">
            <h5>{{ 'TO.Order_CustomerInfo_Company' | translate : 'Company'}}</h5>
            <p>{{ servicePartner?.DeliveryAddressCustomerName }}</p>
          </div>
          <div class="partner-details-row" *ngIf="servicePartner?.DeliveryAddress || servicePartner?.DeliveryZipCode || servicePartner?.DeliveryCity">
            <h5>{{ 'TO.Order_CustomerInfo_Address' | translate : 'Address'}}</h5>
            <p>{{ servicePartner?.DeliveryAddress }}<br *ngIf="servicePartner?.DeliveryAddress && (servicePartner?.DeliveryZipCode || servicePartner?.DeliveryCity)" />{{ servicePartner?.DeliveryZipCode }} {{ servicePartner?.DeliveryCity }}</p>
          </div>
          <div class="partner-details-row" *ngIf="servicePartner?.Phone || servicePartner?.MobilePhone">
            <h5>{{ 'TO.Order_DeliveryAddress_StorePhone' | translate : 'Phone'}}</h5>
            <p>{{ servicePartner?.Phone || servicePartner?.MobilePhone }}</p>
          </div>
          <div class="partner-details-row" *ngIf="servicePartner?.Email">
            <h5>{{ 'TO.Order_CustomerInfo_Email' | translate : 'Email'}}</h5>
            <p><a class="partner-details-value-link" href="mailto:{{ servicePartner?.Email }}">{{ servicePartner?.Email }}</a></p>
          </div>
        </div>
      </section>

      <section class="info-card">
        <h2>{{ 'TO.Order_Contact_RepairPartner' | translate : 'Repair agent'}}</h2>
        <div class="partner-details">
          <div class="partner-details-row" *ngIf="repairPartner?.DeliveryAddressCustomerName">
            <h5>{{ 'TO.Order_CustomerInfo_Company' | translate : 'Company'}}</h5>
            <p>{{ repairPartner?.DeliveryAddressCustomerName }}</p>
          </div>
          <div class="partner-details-row" *ngIf="repairPartner?.DeliveryAddress || repairPartner?.DeliveryZipCode || repairPartner?.DeliveryCity">
            <h5>{{ 'TO.Order_CustomerInfo_Address' | translate : 'Address'}}</h5>
            <p>{{ repairPartner?.DeliveryAddress }}<br *ngIf="repairPartner?.DeliveryAddress && (repairPartner?.DeliveryZipCode || repairPartner?.DeliveryCity)" />{{ repairPartner?.DeliveryZipCode }} {{ repairPartner?.DeliveryCity }}</p>
          </div>
          <div class="partner-details-row" *ngIf="repairPartner?.Phone || repairPartner?.MobilePhone">
            <h5>{{ 'TO.Order_DeliveryAddress_StorePhone' | translate : 'Phone'}}</h5>
            <p>{{ repairPartner?.Phone || repairPartner?.MobilePhone }}</p>
          </div>
          <div class="partner-details-row" *ngIf="repairPartner?.Email">
            <h5>{{ 'TO.Order_CustomerInfo_Email' | translate : 'Email'}}</h5>
            <p><a class="partner-details-value-link" href="mailto:{{ repairPartner?.Email }}">{{ repairPartner?.Email }}</a></p>
          </div>
        </div>
      </section>

      <section class="info-card">
        <h2>{{ 'TO.Order_Contact_UsedPartner' | translate : 'Used partner'}}</h2>
        <div class="partner-details">
          <div class="partner-details-row" *ngIf="usedPartner?.DeliveryAddressCustomerName">
            <h5>{{ 'TO.Order_CustomerInfo_Company' | translate : 'Company'}}</h5>
            <p>{{ usedPartner?.DeliveryAddressCustomerName }}</p>
          </div>
          <div class="partner-details-row" *ngIf="usedPartner?.DeliveryAddress || usedPartner?.DeliveryZipCode || usedPartner?.DeliveryCity">
            <h5>{{ 'TO.Order_CustomerInfo_Address' | translate : 'Address'}}</h5>
            <p>{{ usedPartner?.DeliveryAddress }}<br *ngIf="usedPartner?.DeliveryAddress && (usedPartner?.DeliveryZipCode || usedPartner?.DeliveryCity)" />{{ usedPartner?.DeliveryZipCode }} {{ usedPartner?.DeliveryCity }}</p>
          </div>
          <div class="partner-details-row" *ngIf="usedPartner?.Phone || usedPartner?.MobilePhone">
            <h5>{{ 'TO.Order_DeliveryAddress_StorePhone' | translate : 'Phone'}}</h5>
            <p>{{ usedPartner?.Phone || usedPartner?.MobilePhone }}</p>
          </div>
          <div class="partner-details-row" *ngIf="usedPartner?.Email">
            <h5>{{ 'TO.Order_CustomerInfo_Email' | translate : 'Email'}}</h5>
            <p><a class="partner-details-value-link" href="mailto:{{ usedPartner?.Email }}">{{ usedPartner?.Email }}</a></p>
          </div>
        </div>
      </section>
    </div>
  </div>

  <section class="info-card" *ngIf="customerLocationInfo?.SpecialNote">
    <h2>{{ 'TO.Order.Customer.txtSpecialNote' | translate : 'Special note'}}</h2>
    <p class="special-note">{{ customerLocationInfo?.SpecialNote }}</p>
  </section>
</div>

<div class="loader" *ngIf="loading.dialog">
  <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
  <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading.dialog"></mat-progress-bar>
</div>
